export const submitDevice = ({ commit }) => {
  if(/Android|iP(hone|od|ad)/i.test(navigator.userAgent) || (navigator.userAgent.includes('Macintosh') && navigator.maxTouchPoints >= 1)) commit('SUBMIT_DEVICE', 'm');
  else commit('SUBMIT_DEVICE', 'd');
};

export const submitPlatformType = ({ commit }, type) => {
  commit('SUBMIT_PLATFORM_TYPE', type.toUpperCase())
}

export const submitIOSVersion = ({ commit }) => {
  let deviceVersion = false;
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isAppleDevice = navigator.userAgent.includes('Macintosh');
  const isTouchScreen = navigator.maxTouchPoints >= 1;   // true for iOS 13 (and hopefully beyond)


  if(isIOS || isAppleDevice) {
    if(isTouchScreen) deviceVersion = 13; // and over
    else if(iosQuirkPresent()) deviceVersion = 12; // and under
  }

  commit('SUBMIT_DEVICE_IOS_VERSION', deviceVersion);
};

export const submitIPhone = ({commit}) => {
  const isIPhone = () => {
    if (typeof window === `undefined` || typeof navigator === `undefined`) return false;

    return /iPhone/i.test(navigator.userAgent || navigator.vendor || (Object.toString.call(window.opera) == '[object Opera]'));
  };

  commit('SUBMIT_IS_IPHONE', isIPhone());
}

const iosQuirkPresent = () => {
  const audio = new Audio();
  audio.volume = 0.5;
  return !(audio.volume === 1);   // volume cannot be changed from "1" on iOS 12 and below
};
